// extracted by mini-css-extract-plugin
export default {"loadingcontainer":"loading_loadingcontainer__2Rvuf","loading":"loading_loading__2XyGL","main":"loading_main__wmD5Z"};